import { equals } from 'ramda';
import { normalizeLocation } from './normalizeLocation';
import { TLocation } from 'shared/types/location';

export function needClearGeo(nextLocationRaw: TLocation, currentLocationRaw: TLocation) {
  const nextLocation = normalizeLocation(nextLocationRaw);
  const currentLocation = normalizeLocation(currentLocationRaw);

  // Если выбрана та же локация
  if (equals(nextLocation.map(n => n.id).sort(), currentLocation.map(n => n.id).sort())) {
    return false;
  }

  // Если следующая локация является группой и содержит предыдущую
  if (
    currentLocation.length === 1 &&
    nextLocation.length > 1 &&
    nextLocation.some(next => currentLocation[0].id === next.id)
  ) {
    return false;
  }

  // Если следующая локация является родительской для текущей
  if (nextLocation.some(next => currentLocation.some(current => current.parentId === next.id))) {
    return false;
  }

  return true;
}
